export default __webpack_public_path__ + "static/media/placa-carro.c21d962f.svg";